import { useMatches, useParams } from '@tanstack/react-router';
import { useCallback } from 'react';
import { portfolioItemsEdited } from '@/common/analytics/Avo';

export type PortfolioEditableField =
  | 'teamId'
  | 'estimationId'
  | 'itemStatusId'
  | 'name'
  | 'itemTypeId'
  | 'plannedStartDateTime'
  | 'plannedFinishDateTime';

const PORTFOLIO_EDITABLE_FIELDS: PortfolioEditableField[] = [
  'teamId',
  'estimationId',
  'itemStatusId',
  'name',
  'itemTypeId',
  'plannedStartDateTime',
  'plannedFinishDateTime',
];

export const toPortfolioEditableFields = (keys: string[]): PortfolioEditableField[] =>
  PORTFOLIO_EDITABLE_FIELDS.filter((field) => keys.includes(field));

interface TrackPortfolioItemsEditedParams {
  changedFields: PortfolioEditableField[];
  itemIds: number[];
  isBulkEdit: boolean;
  itemPanel: boolean;
}

export const useTrackPortfolioItemsEdited = () => {
  const matches = useMatches();
  const params = useParams({ strict: false });
  const isPortfolioRoute = matches.some((match) => match.routeId.includes('/portfolio'));
  const loopId = params.loopId;

  return useCallback(
    ({ changedFields, itemIds, isBulkEdit, itemPanel }: TrackPortfolioItemsEditedParams) => {
      if (!isPortfolioRoute || loopId === undefined) return;
      if (changedFields.length === 0 || itemIds.length === 0) return;

      const changed = (field: PortfolioEditableField) => changedFields.includes(field);

      portfolioItemsEdited({
        loopId: String(loopId),
        itemTeamEdited: changed('teamId'),
        itemEffortEdited: changed('estimationId'),
        itemStatusEdited: changed('itemStatusId'),
        itemNameEdited: changed('name'),
        itemTypeEdited: changed('itemTypeId'),
        itemDateFieldEdited: changed('plannedStartDateTime') || changed('plannedFinishDateTime'),
        isBulkEdit,
        itemPanel,
        itemEditedCount: itemIds.length,
        itemIdArray: itemIds.map((id) => ({ itemId: String(id) })),
      });
    },
    [isPortfolioRoute, loopId],
  );
};
